import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import ErpExportTransactionTableFilter from "../Filters/ErpExportTransactionTableFilter";
import moment from "moment";
import { odata } from "../Filters/Helper";
import ErpVirmanMatchedTransaction from "./ErpVirmanMatchedTransaction";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Tooltip,
  Popconfirm,
  Tabs,
  Input,
  Modal,
  Typography,
  Form,
} from "antd";
import {
  BarsOutlined,
  SendOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import FirmTransactionMatchForm from "../Forms/FirmTransactionMatchForm";
import TextArea from "antd/lib/input/TextArea";
import { CurrencyHelper } from "../../util/CurrencyHelper";
import { useMediaQuery } from "react-responsive";
import MultipleAccountTransactionRuleList from "../Rule/MultipleAccountTransactionRuleList";

const EditableCell = ({
  key,
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "number" ? (
      <Input
        type="number"
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
      />
    ) : null;
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Lütfen ${title} giriniz!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};
const ErpExportTransaction = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    activeTab: "0",
    filter: "",
  });
  const [options, setOptions] = useState({ pageTitle: "ERP AKTARIM" });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tenantIdList, setTenantIdList] = useState([
    "381d62ec-9eab-ed11-a2d3-005056b667e2",
  ]);
  const [firmClass, setFirmClass] = useState({
    data: [],
    loading: true,
  });
  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });
  const [firm, setFirm] = useState([]);
  const [columnSettings, setColumnSettings] = useState();
  const [tabKeyValue, setTabKeyValue] = useState();
  const [firmMatchModal, setFirmMatchModal] = useState({
    isUpdate: false,
    isVisible: false,
  });
  const [firmMatchFormData, setFirmMatchFormData] = useState();
  const [chequeNumbers, setChequeNumbers] = useState([]);
  const [projects, setProjects] = useState({
    data: [],
    loading: false,
  });
  const [editingKey, setEditingKey] = useState("");
  const isEditing = (record) => record.id === editingKey;
  const [form] = Form.useForm();
  const [duplicateTake, setDuplicateTake] = useState(15);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const isBigScreen = useMediaQuery({
    query: "(min-device-width: 1824px)",
  });

  const [virmanTransactions, setVirmanTransactions] = useState([]);
  const [virmanPopConfirmVisible, setVirmanPopConfirmVisible] = useState(false);
  const [isCheckedColumnVisible, setIsCheckedColumnVisible] = useState(false);
  const [matchedVirmanTransactions, setMatchedVirmanTransactions] = useState(
    []
  );
  const [
    visibleVirmanMatchedTransactions,
    setVisibleVirmanMatchedTransactions,
  ] = useState(false);

  const [selectedVirmanTransactions, setSelectedVirmanTransactions] = useState(
    []
  );
  const [multipleRuleAddModalVisible, setMultipleRuleAddModalVisible] =
    useState(false);

  const [multipleRuleAddData, setMultipleRuleAddData] = useState([]);

  useEffect(() => {
    const pageOptions = {
      1: {
        pageTitle: "ERP AKTARIM - GELEN",
      },
      2: {
        pageTitle: "ERP AKTARIM - GİDEN",
      },
    };
    if (pageOptions[props.transactionProcessType]) {
      setOptions(pageOptions[props.transactionProcessType]);
    }
  }, []);

  useEffect(() => {
    getColumnSettings();
  }, []);
  useEffect(() => {
    if (columnSettings) {
      getTableData();
      getCurrencies();
    }
  }, [tableDataQueryOptions, columnSettings]);
  const getCurrencies = () => {
    setCurrencySelect({
      data: [],
      loading: true,
    });
    RequestHandler.get(`/Currency?$select=id,code`).then((response) => {
      setCurrencySelect({
        data: response.value,
        loading: false,
      });
    });
  };
  const getTableData = (isRefresh) => {
    setSelectedRowKeys([]);

    //isRefresh eşleştirme sonucu dropdownların state i update olması için
    setTableData(
      isRefresh
        ? {
            data: [],
            total: 0,
            loading: true,
          }
        : { ...tableData, loading: true }
    );
    const { skip, take, filter, activeTab } = tableDataQueryOptions;

    let conditions = ["isManualTransaction Eq false"];
    let query = "";

    if (props.transactionProcessType) {
      conditions.push(
        `TransactionProcessTypeValue Eq ${props.transactionProcessType}`
      );
    }

    if (activeTab !== "-1") {
      conditions.push(`erpTransferStatusId Eq ${activeTab}`);
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = conditions.join(" and ");
    }
    RequestHandler.get(
      `/ErpAccountTransaction?$count=true&$filter=${query}&$skip=${skip}&$top=${take}`
    )
      .then((response) => {
        if (isExportAvailable && response.value) {
          response.value.forEach((x) => {
            if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
              if (
                x.description.split(" ")[2] === "KUR" ||
                (x.description.split(" ")[2] === "KUR" && tabKeyValue === "1")
              ) {
                x.currency = x.description.split(" ")[5]?.substring(0, 3);
                x.currencyExChangeRate = parseFloat(
                  x.description.split(" ")[1].replace(",", ".")
                );
              }
              if (tabKeyValue === "1") {
                x.projectCode =
                  x.description.startsWith("GX-") ||
                  x.description.startsWith("KMARGE-") ||
                  x.description.startsWith("KM-")
                    ? x.description.split("-")[1].substring(0, 5)
                    : x.projectCode;
              }
            }

            if (!x.chaResponsibilityCode) {
              x.chaResponsibilityCode =
                columnSettings.centerOfResponsibilityCode;
            }
          });
        }
        return response;
      })
      .then((response) => {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
        setTotalDataCount(response["@odata.count"]);
      });
  };
  const getFirmClasses = (value) => {
    RequestHandler.get(
      `/FirmClass?$filter=isErpType Eq true&${odata.orderBy("name")}`
    ).then((response) => {
      if (props.transactionProcessType === 2 && !value) {
        const data = response.value.filter(
          (item) => item.name.toLocaleLowerCase() !== "banka"
        );
        setFirmClass({
          data: data,
          loading: false,
        });
      } else {
        setFirmClass({
          data: response.value,
          loading: false,
        });
      }
    });
  };

  const getColumnSettings = () => {
    let isHasvirman = false;
    RequestHandler.get("/TenantErpProgram/GetByTenant").then((response) => {
      if (response) {
        setColumnSettings(response);
        isHasvirman = response.isHasVirmanTransaction;
      } else {
        //erp tanımlı değilse sadece table loaderı kaldırdık
        setTableData({ ...tableData, loading: false });
      }
      getFirmClasses(isHasvirman);
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });

    if (columnSettings?.isHasDuplicateTransaction) {
      setDuplicateTake(p.pageSize);
    }
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
      };
    });
  };

  const onTableSelectChange = (selectedKeys) => {
    setSelectedRowKeys(selectedKeys);
  };

  const onConfirmExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    // tenantAccountErpCode valuesu olmayan bir tenant account hareketi seçili ise
    if (selectedRowsData.some((row) => !row.tenantAccountErpCode)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Erp Kodu' olmayan Hesaba ait kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // erp valuesu olan bir firmClass ve cari seçili değilse
    if (
      !selectedRowsData.every(
        (row) =>
          firmClass.data.some(
            (firmClassHasErpValue) =>
              firmClassHasErpValue.id === row.firmClassId
          ) &&
          row.firmId &&
          row.firmId !== "00000000-0000-0000-0000-000000000000"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Tip' veya 'Cari' seçilmemiş kayıtlar var.",
        duration: 3,
      });
      isSuccess = false;
    }

    // firmBranchNumber valuesu olmayan bir firm seçili ise
    if (selectedRowsData.some((row) => !row.firmBranchNumber)) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde 'Cari Kodu' olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (
      columnSettings?.isHasChequeNumber &&
      selectedRowsData.some(
        (row) => !row.chequeNumber && row.firmClassName == "Çek"
      )
    ) {
      notification.error({
        message:
          "Seçili hesap hareketleri içerisinde Çek Numarası olmayan Cari kayıtları var.",
        duration: 3,
      });
      isSuccess = false;
    }

    if (
      (isSuccess && props.transactionProcessType === 1) ||
      (columnSettings.isHasVirmanTransaction &&
        props.transactionProcessType === 2 &&
        isSuccess)
    ) {
      const possibleVirmanData = selectedRowsData.filter(
        (item) =>
          item.firmClassName.toLocaleLowerCase() === "banka" &&
          !item.isDuplicateTransaction
      );

      if (possibleVirmanData.length > 0)
        RequestHandler.post(
          "/ErpAccountTransaction/CheckVirmanTransaction",
          possibleVirmanData,
          false
        ).then((response) => {
          if (response.length > 0) {
            const virmanData = response.filter((item) => item.isVirman);
            if (virmanData.length > 0) {
              const matchedVirmanTransactions = tableData.data.filter((item) =>
                virmanData.some((element) => element.id === item.id)
              );
              setMatchedVirmanTransactions(virmanData);
              setVirmanTransactions(matchedVirmanTransactions);
              setVisibleVirmanMatchedTransactions(true);
              return;
            } else {
              RequestHandler.post(
                "/ErpAccountTransaction",
                selectedRowsData
              ).then((response) => {
                if (response.success) {
                  getTableData();
                } else {
                  isSuccess = false;
                }
              });
            }
          } else {
            RequestHandler.post(
              "/ErpAccountTransaction",
              selectedRowsData
            ).then((response) => {
              if (response.success) {
                getTableData();
              } else {
                isSuccess = false;
              }
            });
          }
        });
      else {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            } else {
              isSuccess = false;
            }
          }
        );
      }
    } else {
      if (isSuccess) {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            } else {
              isSuccess = false;
            }
          }
        );
      }
    }

    if (columnSettings.useMultipleRuleAddOnErp && isSuccess) {
      const sendDataForRule = selectedRowsData.filter(
        (x) => x.accountTransactionRuleId === null
      );

      if (sendDataForRule.length > 0) {
        openMultipleRuleAddModal(sendDataForRule);
      }
    }
  };

  const openMultipleRuleAddModal = (data) => {
    RequestHandler.get(`/AccountTransactionRule?$count=true`).then(
      (response) => {
        const multipleRuleAddDataJson = data.map((item, index) => ({
          id: item.id,
          key: item.description,
          erpCode: item.firmBranchNumber,
          firmName: item.firmName,
          processType: item.firmClassName,
          firmClassName: item.firmClassName,
          referenceCode: item.referenceCode,
          projectCode: item.projectCode,
          firmId: item.firmId,
          transactionProjectTypeId: item.transactionProjectTypeId,
          tenantAccountId: item.tenantAccountId,
          replaceKey: item.erpDescription,
          name: `OTM${response["@odata.count"] + index + 1}`,
        }));
        setMultipleRuleAddData(multipleRuleAddDataJson);
        setMultipleRuleAddModalVisible(true);
      }
    );
  };

  const onFirmSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/Firm?$select=id,name,firmBranchNumber,firmClassId,firmClassName&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        if (res.value) {
          setFirm(res.value);
        }
      });
    } else {
      setFirm([]);
    }
  };

  const onProjectSearch = (value) => {
    if (value.length >= 2) {
      RequestHandler.get(
        `/TransactionProjectType?$select=id,projectCode,name&$filter=(${odata.contains(
          "name",
          value
        )} or ${odata.contains("projectCode", value)})  and Name ne 'Diğer'`
      ).then((res) => {
        if (res.value) {
          setProjects({ data: res.value, loading: false });
        } else {
          setProjects({ data: [], loading: false });
        }
      });
    }
  };

  const onConfirmSuccessfulExport = () => {
    let isSuccess = true;
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (
      selectedRowsData.some((row) => row.isDuplicateTransaction) &&
      tableDataQueryOptions.activeTab !== "3"
    ) {
      notification.error({
        message: "Seçili hesap hareketleri içerisinde kopya hareketler var.",
        duration: 3,
      });
      isSuccess = false;
    }
    if (isSuccess) {
      selectedRowsData.map((item) => {
        if (item.firmClassId === null) {
          item.firmClassId = "00000000-0000-0000-0000-000000000000";
        }
        if (item.firmId === null) {
          item.firmId = "00000000-0000-0000-0000-000000000000";
        }
      });

      RequestHandler.post(
        "/ErpAccountTransaction/SetSuccessfulTransfer",
        selectedRowsData
      ).then((response) => {
        if (response.success) {
          getTableData();
        }
      });
    }
  };

  const onConfirmNotTransferredExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpAccountTransaction/SetNotTransferredTransfer",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onConfirmVirmanOkExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    if (props.transactionProcessType === 1) {
      const toSetVirmanTransactionsIds = matchedVirmanTransactions
        .filter((item) =>
          selectedVirmanTransactions.some((element) => element.id === item.id)
        )
        .map((x) => x.virmanMatchTransactionId);

      if (toSetVirmanTransactionsIds.length > 0) {
        RequestHandler.post(
          "/ErpAccountTransaction/SetVirmanTransaction",
          toSetVirmanTransactionsIds
        ).then((response) => {
          if (response.success) {
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);

            RequestHandler.post(
              "/ErpAccountTransaction",
              selectedRowsData
            ).then((response) => {
              if (response.success) {
                getTableData();
              }
            });
          }
        });
      } else {
        RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
          (response) => {
            if (response.success) {
              getTableData();
            }
          }
        );
      }
    }
    if (
      props.transactionProcessType === 2 &&
      columnSettings.isHasVirmanTransaction
    ) {
      const toSetSuccessfulTranferTransactions = virmanTransactions.filter(
        (item) =>
          selectedVirmanTransactions.some((element) => element.id !== item.id)
      );

      if (selectedVirmanTransactions.length === 0) {
        virmanTransactions.map((item) => {
          toSetSuccessfulTranferTransactions.push(item);
        });
      }

      const toSetTransferringTransactions = selectedRowsData.filter((item) =>
        toSetSuccessfulTranferTransactions.some(
          (element) => element.id !== item.id
        )
      );

      if (toSetSuccessfulTranferTransactions.length === 0) {
        virmanTransactions.map((item) => {
          toSetTransferringTransactions.push(item);
        });
      }

      if (toSetSuccessfulTranferTransactions.length > 0) {
        RequestHandler.post(
          "/ErpAccountTransaction/SetSuccessfulTransfer",
          toSetSuccessfulTranferTransactions
        ).then((response) => {
          if (response.success) {
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);

            RequestHandler.post(
              "/ErpAccountTransaction",
              toSetTransferringTransactions
            ).then((response) => {
              if (response.success) {
                getTableData();
              }
            });
          }
        });
      } else {
        RequestHandler.post(
          "/ErpAccountTransaction",
          toSetTransferringTransactions
        ).then((response) => {
          if (response.success) {
            getTableData();
            setVirmanTransactions([]);
            setMatchedVirmanTransactions([]);
            setSelectedVirmanTransactions([]);
          }
        });
      }
    }
  };

  const onConfirmIsCheckedExport = () => {
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );
    RequestHandler.post(
      "/ErpAccountTransaction/SetChecked",
      selectedRowsData
    ).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onConfirmVirmanSetSuccessfulExport = () => {
    setVirmanPopConfirmVisible(false);
    const selectedRowsData = tableData.data.filter((row) =>
      selectedRowKeys.includes(row.id)
    );

    selectedRowsData.forEach((item) => {
      if (virmanTransactions.some((c) => c.id == item.id)) {
        item.isSetSuccessful = true;
      }
    });

    RequestHandler.post("/ErpAccountTransaction", selectedRowsData).then(
      (response) => {
        if (response.success) {
          getTableData();
        }
      }
    );
  };
  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
    setTabKeyValue(tabKey);

    if (tabKey === "1") {
      setIsCheckedColumnVisible(true);
    } else {
      setIsCheckedColumnVisible(false);
    }
  };

  const onClickMatchFirm = (isUpdate, data) => {
    setFirmMatchFormData(data);
    setFirmMatchModal({ isUpdate: isUpdate, isVisible: true });
  };

  const getColumns = () => {
    const columnsBeforeDynamicColumns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        width: "8%",
        render: (text) => <img src={text}></img>,
      },
      {
        title: "IBAN / Hesap No",
        dataIndex: "ibanOrAccountNumber",
        width: "1%",
      },
      {
        title: "Tutar",
        dataIndex: "amountString",
        editable: true,
        render: (data) => <span style={{ whiteSpace: "nowrap" }}>{data}</span>,
      },
      {
        title: "Tarih",
        dataIndex: "transactionDate",
        render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
      },
      {
        title: "Cari",
        dataIndex: "firmId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="En az 2 harf giriniz.."
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "50%" }}
            onSearch={onFirmSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                firmId: value,
                firmName: option?.firmName,
                firmClassId: option?.firmClassId,
                firmClassName: option?.firmClassName,
                firmBranchNumber: option?.firmBranchNumber,
                chequeNumbers: [],
                chequeNumber: option?.chequeNumber,
              };
              rows[index] = rowToUpdate;

              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.firmId}
                value={row.firmId}
                firmName={row.firmName}
                firmClassId={row.firmClassId}
                firmBranchNumber={row.firmBranchNumber}
                firmClassName={row.firmClassName}
              >
                {row.firmBranchNumber
                  ? `${row.firmName} (${row.firmBranchNumber})`
                  : row.firmName}
              </Select.Option>
            )}

            {firm
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  firmName={item.name}
                  firmClassId={item.firmClassId}
                  firmBranchNumber={item.firmBranchNumber}
                  firmClassName={item.firmClassName}
                >
                  {item.firmBranchNumber
                    ? `${item.name} (${item.firmBranchNumber})`
                    : item.name}
                </Select.Option>
              ))}
          </Select>
        ),
      },
      {
        title: "Tip",
        dataIndex: "firmClassId",
        width: "10%",
        render: (data, row, index) => {
          const firmClassAvailable = firmClass.data.some((e) => e.id === data);

          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              value={firmClassAvailable ? data : undefined}
              disabled={!isExportAvailable}
              style={{ width: "100%" }}
              loading={firmClass.loading}
              onChange={(value, option) => {
                let rows = [...tableData.data];
                if (
                  columnSettings?.isHasChequeNumber &&
                  option?.children.toLocaleLowerCase("tr-TR") == "çek" &&
                  row.firmId != null
                ) {
                  RequestHandler.post(
                    `/ErpOnare/GetChequeNumbers`,
                    {
                      firmBranchNumber: row.firmBranchNumber,
                    },
                    false,
                    { rawResponse: true }
                  ).then((res) => {
                    let rowToUpdate = {
                      ...row,
                      firmClassId: value,
                      chequeNumbers:
                        res.status == 200
                          ? res.data != ""
                            ? res.data
                            : []
                          : [],
                      firmClassName: option?.children,
                      chequeNumber: option?.chequeNumber,
                    };
                    rows[index] = rowToUpdate;
                    setTableData({ ...tableData, data: rows });
                  });
                } else {
                  let rowToUpdate = {
                    ...row,
                    firmClassId: value,
                    chequeNumbers: [],
                    firmClassName: option?.children,
                    chequeNumber: option?.chequeNumber,
                  };
                  rows[index] = rowToUpdate;

                  setTableData({ ...tableData, data: rows });
                }
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {firmClass.data.map((item) => {
                return (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                );
              })}
            </Select>
          );
        },
      },
    ];

    if (columnSettings?.isHasCenterOfResponsibility) {
      columnsBeforeDynamicColumns.push({
        title: "Sorumluluk Merkezi",
        dataIndex: "chaResponsibilityCode",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Input
              value={data}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  chaResponsibilityCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          );
        },
      });
    }

    if (
      columnSettings?.isHasProjectCode &&
      columnSettings.isHasMatchAccountTransactionRule
    ) {
      columnsBeforeDynamicColumns.push({
        title: "Proje Kodu",
        dataIndex: "transactionProjectTypeId",
        width: "15%",
        render: (data, row, index) => (
          <Select
            allowClear
            showSearch
            placeholder="Seçiniz"
            defaultValue={data ?? undefined}
            disabled={!isExportAvailable}
            style={{ width: "100%" }}
            dropdownStyle={{ minWidth: "30%" }}
            loading={projects.loading}
            onSearch={onProjectSearch}
            onChange={(value, option) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                transactionProjectTypeId: value,
                transactionProjectTypeName: option?.name,
                projectCode: option?.projectCode,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
          >
            {data && (
              <Select.Option
                key={row.transactionProjectTypeId}
                value={row.transactionProjectTypeId}
                name={row.transactionProjectTypeName}
                projectCode={row.projectCode}
              >
                {row.projectCode
                  ? `${row.transactionProjectTypeName} (${row.projectCode})`
                  : row.transactionProjectTypeName}
              </Select.Option>
            )}

            {projects.data
              .filter((item) => item.id != data)
              .map((item) => (
                <Select.Option
                  key={item.id}
                  value={item.id}
                  name={item.name}
                  projectCode={item.projectCode}
                >
                  {item.name + " (" + item.projectCode + ")"}
                </Select.Option>
              ))}
          </Select>
        ),
      });
    }

    if (
      columnSettings?.isHasProjectCode &&
      !columnSettings?.isHasMatchAccountTransactionRule
    ) {
      if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
        columnsBeforeDynamicColumns.push({
          title: "Proje Kodu",
          dataIndex: "projectCode",
          width: "15%",
          render: (data, row, index) => (
            <Input
              style={{ width: 75 }}
              defaultValue={
                data ??
                (row.description.startsWith("GX-") ||
                row.description.startsWith("KMARGE-") ||
                row.description.startsWith("KM-")
                  ? row.description.split("-")[1].substring(0, 5)
                  : undefined)
              }
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  projectCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      } else {
        columnsBeforeDynamicColumns.push({
          title: "Proje Kodu",
          dataIndex: "projectCode",
          width: "15%",
          render: (data, row, index) => (
            <Input
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  projectCode: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      }
    }

    if (columnSettings?.isHasChequeNumber) {
      columnsBeforeDynamicColumns.push({
        title: "Çek Numarası",
        dataIndex: "chequeNumber",
        width: "15%",
        render: (data, row, index) => {
          return (
            <Select
              allowClear
              showSearch
              placeholder="Seçiniz"
              disabled={
                !isExportAvailable ||
                row.firmId == null ||
                row.firmClassName?.toLocaleLowerCase("tr-TR") != "çek"
              }
              value={row.chequeNumber}
              style={{ width: "100%" }}
              onChange={(value) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  chequeNumber: value,
                };
                rows[index] = rowToUpdate;
                setTableData({ ...tableData, data: rows });
              }}
              filterOption={(input, option) =>
                option.children
                  .toLocaleLowerCase("tr-TR")
                  .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
              }
            >
              {row.chequeNumbers?.map((item) => (
                <Select.Option key={item.CHEQUE_ID} value={item.CHEQUE_NO}>
                  {item.CHEQUE_NO} ({item.CHEQUE_VALUE} - {item.CURRENCY_ID})
                </Select.Option>
              ))}
            </Select>
          );
        },
      });
    }

    if (columnSettings?.isHasReferenceCode) {
      columnsBeforeDynamicColumns.push({
        title: "Referans Kodu",
        dataIndex: "referenceCode",
        key: "referenceCode",
        width: "15%",
        render: (data, row, index) => (
          <Input
            value={row.referenceCode}
            defaultValue={data}
            disabled={!isExportAvailable || row.firmId == null}
            onChange={(event) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                referenceCode: event.target.value,
              };
              rows[index] = rowToUpdate;

              setTableData({ ...tableData, data: rows });
            }}
          />
        ),
      });
    }

    if (columnSettings?.isHasMatchAccountTransactionRule) {
      columnsBeforeDynamicColumns.push({
        title: "Erp Açıklama",
        dataIndex: "erpDescription",
        width: "20%",
        render: (data, row, index) => {
          return (
            <TextArea
              value={data}
              disabled={!isExportAvailable}
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  erpDescription: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
              style={{ width: "100%", minWidth: "50%" }}
            />
          );
        },
      });
    }

    if (isCheckedColumnVisible) {
      columnsBeforeDynamicColumns.push({
        title: "Kontrol",
        dataIndex: "isChecked",
        align: "center",
        render: (data) =>
          data === true ? (
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          ) : (
            ""
          ),
      });
    }

    if (columnSettings?.isUseCurrencyExChangeRate) {
      if (tenantIdList.includes(localStorage.getItem("tenantId"))) {
        columnsBeforeDynamicColumns.push({
          title: "Döviz Kuru",
          dataIndex: "currencyExChangeRate",
          align: "center",
          render: (data, row, index) => (
            <Input
              defaultValue={
                !isExportAvailable || tabKeyValue === "3"
                  ? row.currencyExchangeRate
                  : (row.description.split(" ")[2] === "KUR"
                      ? parseFloat(
                          row.description.split(" ")[1].replace(",", ".")
                        )
                      : null) ??
                    data ??
                    undefined
              }
              disabled={!isExportAvailable}
              style={{ width: 87 }}
              type="number"
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  currencyExChangeRate: parseFloat(event.target.value),
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      } else {
        columnsBeforeDynamicColumns.push({
          title: "Döviz Kuru",
          dataIndex: "currencyExchangeRate",
          align: "center",
          width: "8%",
          render: (data, row, index) => (
            <Input
              defaultValue={data ?? undefined}
              disabled={!isExportAvailable}
              type="number"
              onChange={(event) => {
                let rows = [...tableData.data];
                let rowToUpdate = {
                  ...row,
                  currencyExchangeRate: event.target.value,
                };
                rows[index] = rowToUpdate;

                setTableData({ ...tableData, data: rows });
              }}
            />
          ),
        });
      }
    }
    if (columnSettings?.isUseCurrencyExChangeType) {
      columnsBeforeDynamicColumns.push({
        title: "Döviz",
        dataIndex: "currency",
        align: "center",
        width: "8%",
        render: (data, row, index) => (
          <Select
            allowClear
            disabled={!isExportAvailable}
            showSearch
            width={87}
            defaultValue={
              !isExportAvailable || tabKeyValue === "3"
                ? data
                : currencySelect.data.find(
                    (currency) =>
                      currency.code ===
                      row.description.split(" ")[5]?.substring(0, 3)
                  )?.code !== undefined
                ? row.description.split(" ")[5]?.substring(0, 3)
                : "TRY"
            }
            placeholder="Seçiniz"
            filterOption={(input, option) =>
              option.children
                .toLocaleLowerCase("tr-TR")
                .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
            }
            onChange={(value) => {
              let rows = [...tableData.data];
              let rowToUpdate = {
                ...row,
                currency: value,
              };
              rows[index] = rowToUpdate;
              setTableData({ ...tableData, data: rows });
            }}
            loading={currencySelect.loading}
            // disabled={activeCashAccount?.currencyId}
          >
            {currencySelect.data.map(({ id, code }) => (
              <Select.Option key={code} value={code}>
                {code}
              </Select.Option>
            ))}
          </Select>
        ),
      });
    }

    // if(columnSettings?.isUseCurrencyExChangeType){
    //   columnsBeforeDynamicColumns.push({
    //     title: "Döviz Kuru",
    //     dataIndex: "currencyExchangeRate",
    //     align: "center",
    //     width: "8%",
    //     render: (data, row, index) => (
    //       <Input
    //         defaultValue={data ?? undefined}
    //         disabled={!isExportAvailable}
    //         type="number"
    //         onChange={(event) => {
    //           let rows = [...tableData.data];
    //           let rowToUpdate = {
    //             ...row,
    //             currencyExchangeRate: event.target.value,
    //           };
    //           rows[index] = rowToUpdate;

    //           setTableData({ ...tableData, data: rows });
    //         }}
    //       />
    //     ),
    //   });
    // }

    if (columnSettings?.isHasDuplicateTransaction) {
      return columnsBeforeDynamicColumns.concat([
        {
          title: "Açıklama",
          dataIndex: "description",
          render: (text, row, index) => (
            <Tooltip placement="topLeft" title={text}>
              <div style={{ whiteSpace: "break-spaces" }}>
                {text?.trim()?.length > 60
                  ? text.substring(0, 125) + "..."
                  : text}
              </div>
            </Tooltip>
          ),
        },
        {
          title: "Evrak No",
          dataIndex: "documentNumber",
        },
        {
          title: "Durum",
          dataIndex: "erpTransferStatusId",
          align: "center",
          render: (i, row) => {
            const icon = {
              0: {
                component: <InfoCircleOutlined />,
              },
              1: {
                color: "green",
                component: <CheckCircleOutlined />,
              },
              2: {
                color: "orange",
                component: <ClockCircleOutlined />,
              },

              3: {
                color: "red",
                component: <CloseCircleOutlined />,
              },
            };
            return (
              <Tooltip
                title={
                  row.erpTransferStatus === "Başarısız"
                    ? row.errorMessage
                    : row.erpTransferStatus
                }
              >
                <a style={{ fontSize: "130%", color: icon[i].color }}>
                  {icon[i].component}
                </a>
              </Tooltip>
            );
          },
        },
        {
          title: "Kopyala",
          dataIndex: "operation",
          align: "center",
          width: "1%",
          render: (data, row, index) =>
            tableDataQueryOptions.activeTab === "0" ? (
              row.isDuplicateTransaction === false ? (
                <Popconfirm
                  title="Kopyalamak istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => onAdd(index, row)}
                >
                  <a style={{ color: "green", fontSize: "130%" }}>
                    <PlusOutlined />
                  </a>
                </Popconfirm>
              ) : (
                <Popconfirm
                  title="Silmek istiyor musunuz?"
                  okText="Evet"
                  cancelText="Hayır"
                  onConfirm={() => onDelete(row)}
                >
                  <a style={{ color: "red", fontSize: "130%" }}>
                    <DeleteOutlined />
                  </a>
                </Popconfirm>
              )
            ) : (
              ""
            ),
        },
        {
          title: "Düzenle",
          dataIndex: "operation",
          align: "center",
          render: (_, record) =>
            tableDataQueryOptions.activeTab === "0" ? (
              isEditing(record) === true ? (
                <span>
                  <Typography.Link
                    onClick={() => save(record.id)}
                    style={{
                      marginRight: 8,
                    }}
                  >
                    Kaydet
                  </Typography.Link>
                  <Popconfirm
                    title="İptal etmek istiyor musunuz?"
                    onConfirm={cancel}
                  >
                    <a>İptal</a>
                  </Popconfirm>
                </span>
              ) : (
                <Typography.Link
                  disabled={editingKey !== ""}
                  onClick={() => edit(record)}
                >
                  <EditOutlined
                    style={{ color: "orange", fontSize: "130%" }}
                  ></EditOutlined>
                </Typography.Link>
              )
            ) : (
              ""
            ),
        },
      ]);
    }

    return columnsBeforeDynamicColumns.concat([
      {
        title: "Açıklama",
        dataIndex: "description",
        render: (text, row, index) => (
          <Tooltip placement="topLeft" title={text}>
            <div style={{ whiteSpace: "break-spaces" }}>
              {text?.trim()?.length > 60
                ? text.substring(0, 125) + "..."
                : text}
            </div>
          </Tooltip>
        ),
      },
      {
        title: "Evrak No",
        dataIndex: "documentNumber",
      },
      {
        title: "Durum",
        dataIndex: "erpTransferStatusId",
        align: "center",
        render: (i, row) => {
          const icon = {
            0: {
              component: <InfoCircleOutlined />,
            },
            1: {
              color: "green",
              component: <CheckCircleOutlined />,
            },
            2: {
              color: "orange",
              component: <ClockCircleOutlined />,
            },

            3: {
              color: "red",
              component: <CloseCircleOutlined />,
            },
          };
          return (
            <Tooltip
              title={
                row.erpTransferStatus === "Başarısız"
                  ? row.errorMessage
                  : row.erpTransferStatus
              }
            >
              <a style={{ fontSize: "130%", color: icon[i].color }}>
                {icon[i].component}
              </a>
            </Tooltip>
          );
        },
      },
    ]);
  };

  const isExportAvailable =
    tableDataQueryOptions.activeTab === "0" ||
    tableDataQueryOptions.activeTab === "3";

  const isExportToSetNotTransferredAvaiable =
    tableDataQueryOptions.activeTab === "1" ||
    tableDataQueryOptions.activeTab === "3";
  const columns = getColumns();

  const onSuccessFirmMatch = () => {
    setFirmMatchModal({ ...firmMatchModal, isVisible: false });
    getTableData(true);
  };

  const onAdd = async (index, row) => {
    const newData = {
      amount: row.amount,
      amountString: row.amountString,
      bankId: row.bankId,
      bankLogo: row.bankLogo,
      bankName: row.bankName,
      chaResponsibilityCode: row.chaResponsibilityCode,
      chequeNumber: row.chequeNumber,
      chequeNumbers: [],
      currency: row.currency,
      currencyId: row.currencyId,
      description: row.description,
      documentNumber: row.documentNumber,
      erpDescription: row.erpDescription,
      erpTransactionId: row.erpTransactionId,
      erpTransferStatus: row.erpTransferStatus,
      erpTransferStatusId: row.erpTransferStatusId,
      errorMessage: row.errorMessage,
      firmBranchNumber: row.firmBranchNumber,
      firmClassId: row.firmClassId,
      firmClassName: row.firmClassName,
      firmId: row.firmId,
      firmName: row.firmName,
      id: crypto.randomUUID(),
      isManualTransaction: row.isManualTransaction,
      projectCode: row.projectCode,
      referenceCode: row.referenceCode,
      tenantAccountErpCode: row.tenantAccountErpCode,
      tenantAccountId: row.tenantAccountId,
      tenantId: row.tenantId,
      transactionDate: row.transactionDate,
      transactionProcessType: row.transactionProcessType,
      transactionProcessTypeValue: row.transactionProcessTypeValue,
      transactionProjectTypeId: row.transactionProjectTypeId,
      transactionProjectTypeName: row.transactionProjectTypeName,
      transactionTypeId: row.transactionTypeId,
      isDuplicateTransaction: true,
      accountTransactionId: row.accountTransactionId,
      duplicatedTransactionNow: true,
      currencyExChangeRate: row.currencyExChangeRate,
      ibanOrAccountNumber: row.ibanOrAccountNumber,
    };
    const formRow = await form.validateFields();
    const newTableData = [...tableData.data];
    newTableData.splice(index + 1, 0, {
      ...newData,
      ...formRow,
    });
    setDuplicateTake(duplicateTake + 1);
    setTableData({
      data: newTableData,
      loading: false,
      total: totalDataCount + 1,
    });
  };

  const onDelete = (row) => {
    if (!row.duplicatedTransactionNow) {
      RequestHandler.delete(`/ErpDuplicateTransaction/${row.id}`).then(
        (response) => {
          if (!response.success) {
            return;
          }
        }
      );
    }
    setDuplicateTake(duplicateTake - 1);
    setTableData({
      data: tableData.data.filter((item) => item.id != row.id),
      loading: false,
      total: totalDataCount - 1,
    });
  };

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.id);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save = async (key) => {
    const row = await form.validateFields();
    const newData = [...tableData.data];
    const index = newData.findIndex((item) => key === item.id);
    if (index > -1) {
      const item = newData[index];
      var amount = new Intl.NumberFormat("tr-TR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(
        props.transactionProcessType === 1
          ? Math.abs(row.amount)
          : -1 * Math.abs(row.amount)
      );

      item.amount = Math.abs(row.amount);
      item.erpAmount = item.amount;
      item.amountString =
        amount +
        CurrencyHelper.GetCurrencySymbolHelper(
          item.currency.toLocaleLowerCase("tr-TR")
        );

      newData.splice(index, 1, {
        ...item,
        ...row,
      });
      setTableData({ data: newData, loading: false, total: tableData.total });
      setEditingKey("");
    } else {
      newData.push(row);
      setTableData({ data: newData, loading: false, total: tableData.total });
      setEditingKey("");
    }
  };

  const mergedColumns = getColumns().map((col) => {
    if (!col.editable) {
      return col;
    }
    if (col.editable && col.dataIndex == "amountString") {
      return {
        ...col,
        onCell: (record) => ({
          record,
          inputType: "number",
          dataIndex: "amount",
          title: col.title,
          editing: isEditing(record),
        }),
      };
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  return (
    <>
      <Row>
        <Col xs={24} md={8} lg={16} xl={isBigScreen ? 16 : 15}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> {options.pageTitle}
          </p>
        </Col>

        <Col
          hidden={tableDataQueryOptions.activeTab !== "1"}
          xs={24}
          md={8}
          lg={6}
          xl={6}
          style={{ textAlign: "right" }}
        >
          <Popconfirm
            title={
              "Seçili hareketleri kontrol edildi olarak işaretlemek istiyor musunuz?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmIsCheckedExport}
            style={{ color: "seagreen" }}
          >
            <Button
              type="primary"
              disabled={selectedRowKeys.length < 1}
              style={{ marginBottom: 0 }}
            >
              <SendOutlined /> Kontrol Edildi
            </Button>
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={tableDataQueryOptions.activeTab === "1" ? 2 : 4}
          xl={tableDataQueryOptions.activeTab === "1" ? 2 : 6}
          style={{ textAlign: "right", paddingLeft: "0px" }}
        >
          <Popconfirm
            title={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? "Aktarıldı olarak işaretlensin mi?"
                : "Aktarılmadı olarak işaretlensin mi?"
            }
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={
              tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "3"
                ? onConfirmSuccessfulExport
                : onConfirmNotTransferredExport
            }
            style={{ color: "seagreen" }}
          >
            {(tableDataQueryOptions.activeTab === "0" ||
              tableDataQueryOptions.activeTab === "1" ||
              tableDataQueryOptions.activeTab === "3") && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined />{" "}
                {(tableDataQueryOptions.activeTab === "0" ||
                  tableDataQueryOptions.activeTab === "3") &&
                  "Aktarıldı Yap"}
                {tableDataQueryOptions.activeTab === "1" && "Aktarılmadı Yap"}
              </Button>
            )}
          </Popconfirm>
        </Col>
        <Col
          xs={24}
          md={8}
          lg={4}
          xl={2}
          style={{ textAlign: "right" }}
          hidden={tableDataQueryOptions.activeTab === "1"}
        >
          <Popconfirm
            title="Aktarmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            placement="bottom"
            disabled={selectedRowKeys.length < 1}
            onConfirm={onConfirmExport}
          >
            {isExportAvailable && (
              <Button
                type="primary"
                disabled={selectedRowKeys.length < 1}
                style={{ marginBottom: 0 }}
              >
                <SendOutlined /> Erp'ye Aktar
              </Button>
            )}
          </Popconfirm>

          <Popconfirm
            visible={virmanPopConfirmVisible}
            title="Seçilen hareketler arasında virman hareketler bulunmaktadır.
             Bu hareketlerin Erp'ye aktarılmasını istiyor musunuz?"
            okText="Evet Aktar"
            cancelText="Hayır Aktarıldı Yap"
            placement="bottom"
            onConfirm={onConfirmVirmanOkExport}
            onCancel={onConfirmVirmanSetSuccessfulExport}
          ></Popconfirm>
        </Col>
      </Row>
      <ErpExportTransactionTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs
        defaultActiveKey={tableDataQueryOptions.activeTab}
        onChange={onTabChange}
      >
        <Tabs.TabPane tab="Tümü" key="-1" />
        <Tabs.TabPane tab="Aktarılmadı" key="0" />
        <Tabs.TabPane tab="Başarılı" key="1" />
        <Tabs.TabPane tab="Aktarılıyor" key="2" />
        <Tabs.TabPane tab="Başarısız" key="3" />
      </Tabs>

      <Row id="tableArea">
        <Col span={24}>
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              rowSelection={
                isExportAvailable
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : tableDataQueryOptions.activeTab === "1"
                  ? {
                      selectedRowKeys: selectedRowKeys,
                      onChange: onTableSelectChange,
                    }
                  : undefined
              }
              columns={
                columnSettings?.isHasDuplicateTransaction
                  ? mergedColumns
                  : columns
              }
              locale={{
                emptyText: (
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description="Veri Yok"
                  />
                ),
              }}
              style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
              rowKey="id"
              filterable={true}
              sortable={true}
              pageable={true}
              onChange={paging}
              pagination={{
                defaultPageSize: columnSettings?.isHasDuplicateTransaction
                  ? duplicateTake
                  : tableDataQueryOptions.take,
                pageSizeOptions: ["15", "25", "50", "100"],
                total: tableData.total,
                current: tableDataQueryOptions.current,
                pageSize: columnSettings?.isHasDuplicateTransaction
                  ? duplicateTake
                  : tableDataQueryOptions.take,
              }}
              dataSource={tableData.data}
              loading={tableData.loading}
              size="small"
            />
          </Form>
        </Col>
      </Row>

      <Modal
        centered
        title={
          firmMatchModal.isUpdate
            ? "Kayıtlı Cari Güncelle"
            : "Kayıtlı Cari Eşleştir"
        }
        visible={firmMatchModal.isVisible}
        onCancel={() =>
          setFirmMatchModal({ ...firmMatchModal, isVisible: false })
        }
        footer={null}
      >
        <FirmTransactionMatchForm
          onSuccess={onSuccessFirmMatch}
          isUpdate={firmMatchModal.isUpdate}
          data={firmMatchFormData}
        />
      </Modal>

      <Modal
        title={"Virman Hesap Hareketleri"}
        visible={visibleVirmanMatchedTransactions}
        centered={true}
        keyboard={true}
        onOk={() => {
          onConfirmVirmanOkExport();
          setVisibleVirmanMatchedTransactions(false);
        }}
        onCancel={() => {
          setVisibleVirmanMatchedTransactions(false);
        }}
        width={1000}
        destroyOnClose={true}
      >
        <ErpVirmanMatchedTransaction
          Data={virmanTransactions}
          SelectedVirmanTransactions={(selectedVirmanTransactions) =>
            setSelectedVirmanTransactions(selectedVirmanTransactions)
          }
          transactionProcessType={props.transactionProcessType}
        />
      </Modal>

      <Modal
        visible={multipleRuleAddModalVisible}
        centered={true}
        keyboard={true}
        onCancel={() => {
          setMultipleRuleAddModalVisible(false);
        }}
        width={1000}
        destroyOnClose={true}
        okButtonProps={{ hidden: true }}
        closable={false}
        maskClosable={false}
        footer={[
          <Popconfirm
            title="Eklenmeyen kurallar var. Kural Ekleme işlemini iptal etmek istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => setMultipleRuleAddModalVisible(false)}
          >
            <Button key="back">İptal</Button>
          </Popconfirm>,
        ]}
      >
        <MultipleAccountTransactionRuleList
          data={multipleRuleAddData}
          onSuccess={() => {
            setMultipleRuleAddModalVisible(false);
          }}
        />
      </Modal>
    </>
  );
};
export default ErpExportTransaction;
